import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { urlHelper } from 'src/app/helpers';
import { axiosc } from 'src/app/utils';
import { queryTypes, servicesIkmalSiniflariTypes } from 'src/types';

export const ikmalSiniflariLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  load,
  blockSpinner,
}: servicesIkmalSiniflariTypes.IkmalSiniflariLookupDataType): AxiosPromise<servicesIkmalSiniflariTypes.IkmalSiniflariLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (load) {
    query.load = load.join(',');
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.ikmalSiniflari), {
    blockSpinner,
  });
};
